import { render, staticRenderFns } from "./FantasyFarm.vue?vue&type=template&id=d4c6c172&scoped=true"
import script from "./FantasyFarm.vue?vue&type=script&lang=js"
export * from "./FantasyFarm.vue?vue&type=script&lang=js"
import style0 from "./FantasyFarm.vue?vue&type=style&index=0&id=d4c6c172&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c6c172",
  null
  
)

export default component.exports